import { __makeTemplateObject, __rest, __assign } from 'tslib';
import React from 'react';
import { css, styled } from 'styled-components';
import { resets } from '../utils/index.js';

var hResets = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  display: block;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"], ["\n  ", "\n  ", "\n  display: block;\n  max-width: 100%;\n  word-wrap: normal;\n  word-break: normal;\n  white-space: normal;\n"])), resets.normalize.html, resets.common);
var StyledHtmlH = styled.h1.withConfig({
  componentId: "sc-6tmfx8-0"
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), hResets);
var HtmlH = function HtmlH(_a) {
  var forwardedRef = _a.forwardedRef,
    children = _a.children,
    passProps = __rest(_a, ["forwardedRef", "children"]);
  return /*#__PURE__*/React.createElement(StyledHtmlH, __assign({
    ref: forwardedRef
  }, passProps), children);
};
var templateObject_1, templateObject_2;

export { HtmlH };
//# sourceMappingURL=HtmlH.js.map
